import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BUYER_CARD_BASE_URL } from '../config/settings/environment'

/**
 * Get Purchase Orders information.
 */
export const getPurchaseOrders = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_BUYER_CARD_BASE_URL}/orden_compra/montos?rut=${dni}`)
})
